"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLine = createLine;
var _konva = _interopRequireDefault(require("konva"));
var _ = _interopRequireDefault(require(".."));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function createLine(_ref) {
  var layer = _ref.layer,
    x = _ref.x,
    y = _ref.y,
    xx = _ref.xx,
    yy = _ref.yy,
    max = _ref.max,
    min = _ref.min,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    name = _ref.name;
  var stage = layer.getParent();
  var group = new _konva.default.Group({
    draggable: false,
    id: id,
    name: "Line"
  });

  // line marker text
  _.default.label({
    parent: group,
    text: name,
    position: {
      x: x,
      y: y
    },
    offset: {
      x: 15,
      y: 15
    },
    rotation: -stage.rotation()
  });

  // statistics label
  _.default.label({
    parent: group,
    text: "Max: ".concat(max, "\nMin: ").concat(min),
    position: {
      x: (xx + x) / 2,
      y: (yy + y) / 2
    },
    offset: {
      x: -5,
      y: -5
    },
    rotation: -stage.rotation()
  });
  var lineMarker = new _konva.default.Line({
    points: [x, y, xx, yy],
    stroke: "white",
    tension: 1,
    className: "line"
  });
  group.add(lineMarker);
  layer.draw();
  layer.add(group);
}